import { ReportingConfigOptions } from '../../../common/models/Configuration/Reporting';
import { ChangeTracker } from '../../../common/models/hooks/ChangeTracker';

export const DefaultOptions: ReportingConfigOptions = {
  AnalyticsActivityNumbersBasedOn: '1',
  AnalyticsContractBillingsBasedOn: '0',
  AnalyticsPermBillingsBasedOn: '0',
  AnalyticsPlacementNumbersBasedOn: '0',
  RevenueCalculationMethod: '1',
  ForecastingMode: '0',
  NetRevenueName: 'Net Revenue',
  StretchLabelOverride: '',
  TargetLabelOverride: '',
  YearStart: '1',
};

export const NoChangesTracker: ChangeTracker<ReportingConfigOptions> = {
  AnalyticsActivityNumbersBasedOn: false,
  AnalyticsContractBillingsBasedOn: false,
  AnalyticsPermBillingsBasedOn: false,
  AnalyticsPlacementNumbersBasedOn: false,
  RevenueCalculationMethod: false,
  ForecastingMode: false,
  NetRevenueName: false,
  StretchLabelOverride: false,
  TargetLabelOverride: false,
  YearStart: false,
};
